/**
 * GBrainMethodologyPanel
 *
 * Static reference: what G-Brain is, what patterns mean, what to look for
 */
export function GBrainMethodologyPanel(): React.ReactElement {
  return (
    <div className="space-y-2">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-text-tertiary">
        What is G-Brain?
      </div>
      <div className="space-y-1.5 text-[10px] text-text-secondary">
        <div>
          <span className="font-semibold text-text-primary">Patterns</span> are learned behaviors
          the system discovers: architectural decisions, performance optimizations, testing
          strategies, security patterns.
        </div>
        <div>
          <span className="font-semibold text-text-primary">Categories</span> organize patterns:
          architecture, performance, reliability, security, scalability, maintainability.
        </div>
        <div>
          <span className="font-semibold text-text-primary">Confidence</span> scores reflect how
          consistently the pattern appears. Higher = more reliable.
        </div>
        <div>
          <span className="font-semibold text-text-primary">Timeline</span> shows when each pattern
          was discovered — recent patterns may be emergent, older ones are established.
        </div>
        <div className="pt-1 border-t border-border/50">
          Use G-Brain to understand your project&apos;s methodology, accelerate new team members,
          and maintain consistency as the codebase evolves.
        </div>
      </div>
    </div>
  );
}
